import { CROSS_TENANT_HISTORY_STATES, CROSS_TENANT_HISTORY_STATES_RECEIVER } from '@/class/cargo/model/parameters/SeaExportConstants'
import { DateAutoInitRuleManage } from '@/class/cargo/model/utils/DateAutoInitRuleManage'
import { AutoContaninerFactory } from '@/class/cargo/model/utils/AutoContaninerFactory'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import DateUtils from '@/utils/dateUtils'
import { CrossTenantHistory } from '@/class/model/booking/CrossTenantHistory'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { Vessel } from '@/class/model/mdm/Vessel'
import { Voyage } from '@/class/model/mdm/Voyage'
import { loadSpecificBasicInfo } from '@/api/cache'
import { getContractNoList } from '@/api/seaExport/contractNo'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getSubscribePortPushTenantList, querySubscribeConfig } from '@/api/sysManage/subscribePortPushRule'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { dateCompare, mergeArray } from '@/utils/commonUtil'
import { Company } from '@/class/model/mdm/Company'
import checkPermission from '@/utils/permission'
import {
  getShippingScheduleDistrict,
  shippingSchedules
} from '@/api/seaExport/dataTracking'
import { CargoDocUtil as cargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import LocalStorageUtils from '@/utils/localStorageUtils'
import $store from '@/store'
import { TabBookingAbstract } from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingAbstract'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getNacInfo } from '@/api/price/priceFcl'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export class TabVesselEqPM {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    this.view = view
    this.sinOTranErrorLogWindow = null
    this.arrEIRaddress = []
    this.currentVessel = null
    this.title = ''
    this.ediFileName = null
    this.ediType = 0
    this.ediDatas = null
    this.ediTemplate = null // edi模板
    this.ediNoRuleConfigMode = 0 // 多号规范配置 参数控制
    this.ruleConfigWindow = null // 多号规范配置
    this.editStatus = 0
    this.ediTabWindow = null
    this.editVesselVoyageMode = 2 // 船名编辑模式
    this.editVoyageMode = 2 // 航次
    this.selectedJobs = null // 选择edi
    this.isCrossJob = false // 是否为跨tenant业务
    this.isShowSalesFileCutoffDate = true
    this.lclslaveEnabled = false
    this.lclslaveEnabledExcludeExportToImport = false
    this._allowEditingVessel = false
    this._voyages = null
    this.voyageList = []
    this._uploadUtil = null
    this._ediWin = null
    this.vesselList = []
    this.statusFlag = new Map()
    this.openSubscribePortPush = false
    this.syncSignDateBl = 0
    this.combinedManifest = 0
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = this.view.synchronousShipperCodeAndConsigneeCodeAndNotifyCode // 是否同步收发通代码到基本页签
    this.nacList = []
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    this.view.context = context
  }
  get user() {
    return this.view.context.user
  }
  set user(user) {
    this.view.context.user = user
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    this.view.config = config
  }
  get job() {
    return this.view.form
  }
  set job(job) {
    this.view.form = job
  }
  get mblCargoDoc() {
    return this.view.mblCargoDoc
  }
  set mblCargoDoc(mblCargoDoc) {
    this.view.mblCargoDoc = mblCargoDoc
  }
  /**
   * 订舱
   */
  bookingMenuEvent(index) {
    // switch (index) {
    //   // case '更正':
    //   //   this.btnBookingEdiEditClickHandler()
    //   //   break
    //   case 'FTP1':
    //     this.btnBookingEdiNewClickHandler()
    //     break
    //   case 'FTP0':
    //     this.btnBookingEdiEditClickHandler()
    //     break
    //   case 'API0':
    //     this.sinOTransApi()
    //     break
    //   case 'API1':
    //     this.sinOTransUpdateApi()
    //     break
    //   case this.view.$t('SeaExport.ReceiptImport'):
    //     this.btnBookingEdiReceiptClickHandler()
    //     break
    //   default:
    //     this.btnBookingEdiNewClickHandler()
    //     break
    // }
  }
  /**
   * 中外运api 原始
   */
  sinOTransApi() {
    // if (_view.job == null) {
    //   MessageDialog.warning(this.view.$t('SeaExport.NoBusinessSelected'))
    //   return
    // }
    // var sea: SeaExportJob = _view.job as SeaExportJob
    // EDI.getSinOTransApi(sea.key, "1", apiSuccess)
  }
  /**
   * 中外运api 更新
   */
  sinOTransUpdateApi() {
    // if (_view.job == null) {
    //   MessageDialog.warning(this.view.$t('SeaExport.NoBusinessSelected'))
    //   return
    // }
    // var sea: SeaExportJob = _view.job as SeaExportJob
    // EDI.getSinOTransApi(sea.key, "2", apiSuccess)
  }
  /**
   * 成功
   */
  apiSuccess(event) {
    //   var o = event.result as Object
    //   if (o) {
    //     var success = o.isSuccess as Boolean
    //     if (success) {
    //       MessageDialog.success("请求成功！")
    //     } else {
    //       var text = o.text
    //       if (sinOTranErrorLogWindow == null) {
    //         sinOTranErrorLogWindow = new SinOTranErrorLogWindow()
    //       }
    //       var textStr = text.substring(0, text.length - 5) + text.substring(text.length - 5, text.length).replace("", "")
    //       sinOTranErrorLogWindow.errorLog = textStr
    //       PopUpUtils.addPopUp(sinOTranErrorLogWindow, view, true)
    //     }
    //   }
  }
  /**
   * 订舱更正
   */
  btnBookingEdiEditClickHandler() {
    //   if (_view.job == null) {
    //     MessageDialog.warning(this.view.$t('SeaExport.NoBusinessSelected'))
    //     return
    //   }
    //   selectedJobs = new ArrayCollection()
    //   selectedJobs.addItem(_view.job.key)
    //   if (Config.configMap["creditOpen"] == "1") {
    //     CreditControlUtil.checkCreditByCompany(_view.job.customerId, function (credit: CreditInfo) {
    //       var canEdi = true
    //       if (credit != null) {
    //         var tip = ""
    //         if (credit.isAmountExceeded || credit.isDateExceeded) {
    //           var config = CreditControlUtil.getCreditEDISetting()
    //           if (config.booking) {
    //             if (credit.isAmountExceeded)
    //               tip += this.view.$t('Partners.limit')
    //             if (credit.isDateExceeded)
    //               tip += this.view.$t('Partners.accountPeriod')
    //             MessageDialog.info(this.view.$t('SeaExport.CreditControlTheClient') + tip + this.view.$t('SeaExport.HasExceededCannotEDI'), null, null, null)
    //             canEdi = false
    //           }
    //         }
    //       }
    //       if (canEdi) {
    //         title = this.view.$t('SeaExport.BookingCorrection')
    //         ediType = 1
    //         editStatus = 4
    //         if (Config.configMap["useEDITemplate"] == "1") {
    //           showEDITemplateWin(selectedJobs)
    //         } else {
    //           EDI.getBookingEDI(selectedJobs, editStatus, onExportEDISuccess, onExportEDIFailed)
    //         }
    //       }
    //     })
    //   }
    //   else {
    //     title = this.view.$t('SeaExport.BookingCorrection')
    //     ediType = 1
    //     editStatus = 4
    //     if (Config.configMap["useEDITemplate"] == "1") {
    //       showEDITemplateWin(selectedJobs)
    //     } else {
    //       EDI.getBookingEDI(selectedJobs, editStatus, onExportEDISuccess, onExportEDIFailed)
    //     }
    //   }
  }
  /**
   * 成功
   */
  onExportEDISuccess(event) {
    //   ediDatas = event.result as Object
    //   if (ediDatas == null) {
    //     MessageDialog.info("此单没有可导的EDI", null, null, null)
    //     return
    //   }
    //   if (ediTabWindow == null) {
    //     ediTabWindow = new EdiTabWindow()
    //     ediTabWindow.addEventListener(FlexEvent.CONTENT_CREATION_COMPLETE, ediTabWindowCompleteHandler)
    //   }
    //   else {
    //     setEdiTabWindow()
    //   }
    //   PopUpUtils.addPopUp(ediTabWindow, view, true)
    // }
    // ediTabWindowCompleteHandler(evt) {
    //   ediTabWindow.removeEventListener(FlexEvent.CONTENT_CREATION_COMPLETE, ediTabWindowCompleteHandler)
    //   setEdiTabWindow()
    // }
    // setEdiTabWindow() {
    //   ediTabWindow.job = view.job as Job
    //   ediTabWindow.title = title
    //   ediTabWindow.ediType = ediType
    //   ediTabWindow.ediFileName = ediFileName
    //   ediTabWindow.ediCollection = ediDatas
    //   ediTabWindow.ediTemplate = ediTemplate
    //   ediTabWindow.addEidNavigator()
    // }
    // win_closeHandler(e) {
    //   e.target.visible = false
    // }
    // showEDITemplateWin(uuids, item = null) {
    //   if (_ediWin == null) {
    //     _ediWin = new EDIPopup()
    //     _ediWin.addEventListener(CloseEvent.CLOSE, win_closeHandler)
    //     _ediWin.addEventListener("ok", getEDI)
    //     PopUpManager.addPopUp(_ediWin, _view, false)
    //     PopUpManager.centerPopUp(_ediWin)
    //     _ediWin.visible = false
    //   }
    //   _ediWin.title = title
    //   _ediWin.templateType = ediType
    //   if (uuids) {
    //     _ediWin.uuids = uuids
    //   } else {
    //     _ediWin.item = item
    //   }
    //   _ediWin.load()
    //   _ediWin.visible = true
  }
  /**
   * 选择模板
   */
  getEDI(event = null) {
    //   if (_ediWin.selectedItem) {
    //     if (ediNoRuleConfigMode == 1 && ediType == 5) {
    //       if (ruleConfigWindow == null) {
    //         ruleConfigWindow = new EDINoRuleConfigWindow()
    //         ruleConfigWindow.addEventListener("export", exportHandler2)
    //         ruleConfigWindow.addEventListener("enter", enterHandler2)
    //       }
    //       PopUpUtils.addPopUp(ruleConfigWindow, view, true)
    //     }
    //     else {
    //       enterHandler2()
    //     }
    //   }
  }
  exportHandler2(event) {
    //   ruleConfigWindow = null
    //   enterHandler2()
  }
  enterHandler2(event = null) {
    //   ediTemplate = _ediWin.selectedItem as EDIPartnerTemplate
    //   var ruleEDINos = null
    //   if (ruleConfigWindow && ediNoRuleConfigMode == 1 && ediType == 5) {
    //     ruleEDINos = new ArrayCollection(ruleConfigWindow.ruleEDINos)
    //   }
    //   if (_ediWin.item == null) {
    //     EDI.getEDI(ediType, _ediWin.selectedItem.key, _ediWin.uuids, editStatus, ruleEDINos, onExportEDISuccess, onExportEDIFailed)
    //   }
    //   else {
    //     _ediWin.item.ruleEDINos = ruleEDINos
    //     EDI.getEDIObject(ediType, _ediWin.selectedItem.key, _ediWin.item, editStatus, onExportEDISuccess, onExportEDIFailed)
    //   }
  }
  /**
   * 订舱EDI(New)
   */
  btnBookingEdiNewClickHandler() {
    //   if (view.job == null) {
    //     MessageDialog.warning("未选择业务.")
    //     return
    //   }
    //   selectedJobs = new ArrayCollection()
    //   selectedJobs.addItem(view.job.key)
    //   if (Config.configMap["creditOpen"] == "1") {
    //     CreditControlUtil.checkCreditByCompany(view.job.customerId, function (credit: CreditInfo) {
    //       var canEdi = true
    //       if (credit != null) {
    //         var tip = ""
    //         if (credit.isAmountExceeded || credit.isDateExceeded) {
    //           var config = CreditControlUtil.getCreditEDISetting()
    //           if (config.booking) {
    //             if (credit.isAmountExceeded)
    //               tip += this.view.$t('Partners.limit')
    //             if (credit.isDateExceeded)
    //               tip += this.view.$t('Partners.accountPeriod')
    //             MessageDialog.info(this.view.$t('SeaExport.CreditControlTheClient') + tip + this.view.$t('SeaExport.HasExceededCannotEDI'), null, null, null)
    //             canEdi = false
    //           }
    //         }
    //       }
    //       if (canEdi) {
    //         title = this.view.$t('SeaExport.BookingEDI')
    //         ediType = 1
    //         editStatus = 9
    //         if (Config.configMap["useEDITemplate"] == "1") {
    //           showEDITemplateWin(selectedJobs)
    //         } else {
    //           EDI.getBookingEDI(selectedJobs, editStatus, onExportEDISuccess, onExportEDIFailed)
    //         }
    //       }
    //     })
    //   }
    //   else {
    //     title = this.view.$t('SeaExport.BookingEDI')
    //     ediType = 1
    //     editStatus = 9
    //     if (Config.configMap["useEDITemplate"] == "1") {
    //       showEDITemplateWin(selectedJobs)
    //     } else {
    //       EDI.getBookingEDI(selectedJobs, editStatus, onExportEDISuccess, onExportEDIFailed)
    //     }
    //   }
  }
  /**
   * 失败
   */
  onExportEDIFailed(event) {
    //   var result = event.fault.faultString
    //   var resultArray = result.split("")
    //   var modelMap = ModelMap.ProperyLabelMap
    //   var errorMsg = ""
    //   var error = this.view.$t('SeaExport.ItIsEmpty') + "\n"
    //   if (resultArray != null && resultArray.length > 0) {
    //     for each(var key in resultArray)
    //     {
    //       var jobValue = key.split(".")
    //       if (jobValue != null && jobValue.length > 0) {
    //         var comObj = modelMap[jobValue[0]]
    //         if (comObj != null) {
    //           errorMsg += comObj[jobValue[1]] + error
    //         }
    //       } else {
    //         errorMsg += key
    //       }
    //     }
    //     if (errorMsg != "") {
    //       MessageDialog.warning(errorMsg, null, null, null)
    //     }
    //     else {
    //       MessageDialog.showFault(event)
    //     }
    //   }
    //   else {
    //     MessageDialog.showFault(event)
    //   }
  }
  /**
   * 订舱回执导入
   */
  btnBookingEdiReceiptClickHandler() {
    //   if (view.job == null) {
    //     MessageDialog.warning("未选择业务.")
    //     return
    //   }
    //   if (_uploadUtil == null) {
    //     _uploadUtil = new UploadUtils(LOGGER)
    //     _uploadUtil.addEventListener(UploadUtils.FILE_LOAD_COMPLETE, onLoadComplete)
    //   }
    //   _uploadUtil.loadPmsFile()
  }
  onLoadComplete(e) {
    //   var fr: FileReference = (e.target as UploadUtils).fr
    //   Session.getInstance().callService("PoItemsService", "savePmsFile",
    //     new mx.rpc.Responder(onImportSucceeded, onImportFailed), _uploadUtil.xlsData)
  }
  // /**
  //  * 订舱回执导入 解析信息
  //  */
  // exportJob: SeaExportJob
  onImportSucceeded(event) {
    //   exportJob = event.result as SeaExportJob
    //   var seaExportJob: SeaExportJob = view.job as SeaExportJob
    //   if (seaExportJob.needLoadCargoDoc()) {
    //     seaExportJob.loadCargoDoc(new Responder(loadCargoDocHandler, onImportFailed))
    //   }
    //   else {
    //     loadCargoDocHandler()
    //   }
  }
  loadCargoDocHandler(evt = null) {
    //   var seaExportJob: SeaExportJob = view.job as SeaExportJob
    //   if (exportJob == null) {
    //     MessageDialog.info(this.view.$t('SeaExport.ReceiptImportFailed'), this.view.$t('Message.Prompt'), null, null)
    //     return
    //   }
    //   if (exportJob.mbl != seaExportJob.mbl) {
    //     MessageDialog.confirm(this.view.$t('SeaExport.PrimaryOrderNotSameReceipt'), this.view.$t('SeaExport.Confirm'), null, function (event) {
    //       if (event.detail == Alert.YES) {
    //         updateSeaJobsFromReceipt()
    //       }
    //     })
    //   } else {
    //     updateSeaJobsFromReceipt()
    //   }
  }
  updateSeaJobsFromReceipt() {
    //   //检查对单状态是否是未开始
    //   var seaExportJob: SeaExportJob = view.job as SeaExportJob
    //   var docs = seaExportJob.cargoDoc
    //   var flag = false
    //   for each(var doc: SeaCargoDoc in docs)
    //   {
    //     if (doc.docType == CargoDocConsts.MBL && doc.cfmState == 0) {
    //       flag = true
    //       break
    //     }
    //   }
    //   if (!flag) {
    //     CursorManager.getInstance().removeAllCursors()
    //     MessageDialog.warning(this.view.$t('SeaExport.MBLStatusNotIsUnStart'), this.view.$t('SeaExport.Tips'))
    //     return
    //   }
    //   Session.getInstance().callService("SeaExportJobService", "updateSeaJobsFromReceipt", new mx.rpc.Responder(onReceiptupdateSucceeded, onReceiptupdateFailed), seaExportJob, exportJob)
  }
  static onImportFailed(event) {
    //   CursorManager.getInstance().removeAllCursors()
    //   MessageDialog.showFault(event)
  }
  onReceiptupdateSucceeded(event) {
    //   //导入成功，触发sop状态
    //   var seaJob = view.job
    //   Session.getInstance().callService("TrackingService", "updateTrackingByEvent",
    //     new mx.rpc.Responder(trackingUpdateSucceeded, trackingUpdateFailed), seaJob.key, "_edi_receipt_import")
  }
  static onReceiptupdateFailed(event) {
    //   CursorManager.getInstance().removeAllCursors()
    //   MessageDialog.info(this.view.$t('SeaExport.ReceiptImportFailed'), null, null, null)
  }
  static trackingUpdateSucceeded(event) {
    //   CursorManager.getInstance().removeAllCursors()
    //   MessageDialog.info(this.view.$t('SeaExport.ReceiptImportedSuccessfully'), null, null, null)
  }
  static trackingUpdateFailed(event) {
    //   CursorManager.getInstance().removeAllCursors()
    //   MessageDialog.info(this.view.$t('SeaExport.NodeTriggerFailed'), null, null, null)
  }
  /**
   * 提单更正
   */
  btnBlEdiEditClickHandler() {
    //   if (view.job == null || !(view.job is SeaExportJob))
    //   {
    //     MessageDialog.warning("未选择业务.")
    //     return
    //   }
    //   if (Config.configMap["creditOpen"] == "1") {
    //     CreditControlUtil.checkCreditByCompany(view.job.customerId, function (credit: CreditInfo) {
    //       var canEdi = true
    //       if (credit != null) {
    //         var tip = ""
    //         if (credit.isAmountExceeded || credit.isDateExceeded) {
    //           var config = CreditControlUtil.getCreditEDISetting()
    //           if (config.bl) {
    //             if (credit.isAmountExceeded)
    //               tip += this.view.$t('CargoMsg.Cargo_Limit')
    //             if (credit.isDateExceeded)
    //               tip += this.view.$t('CargoMsg.Cargo_AccountPeriod')
    //             MessageDialog.info(this.view.$t('SeaExport.CreditControlTheClient') + tip + this.view.$t('SeaExport.HasExceededCannotEDI'), null, null, null)
    //             canEdi = false
    //           }
    //         }
    //       }
    //       if (canEdi) {
    //         title = this.view.$t('SeaExport.CorrectionBillOfLading')
    //         ediType = 2
    //         editStatus = 4
    //         if (Config.configMap["useEDITemplate"] == "1") {
    //           showEDITemplateWin(new ArrayCollection([view.job.key]))
    //         } else {
    //           EDI.getLadingBillEDI(view.job.key, editStatus, onExportEDISuccess, onExportEDIFailed)
    //         }
    //       }
    //     })
    //   }
    //   else {
    //     title = this.view.$t('SeaExport.CorrectionBillOfLading')
    //     ediType = 2
    //     editStatus = 4
    //     if (Config.configMap["useEDITemplate"] == "1") {
    //       showEDITemplateWin(new ArrayCollection([view.job.key]))
    //     } else {
    //       EDI.getLadingBillEDI(view.job.key, editStatus, onExportEDISuccess, onExportEDIFailed)
    //     }
    //   }
  }
  /**
   * 提单EDI(New)
   */
  btnBlEdiNewClickHandler() {
    //   if (view.job == null || !(view.job is SeaExportJob))
    //   {
    //     MessageDialog.warning("未选择业务.")
    //     return
    //   }
    //   if (view.job.needLoadContainers()) {
    //     var responder: IResponder = new mx.rpc.Responder(addBillEdi, onContainerLoadFailed)
    //     var paramMap = { Containers: true }
    //     Session.getInstance().callService("JobService", "loadJobParams",
    //       new ResponderDelegate(responder, onContainerLoaded, onContainerLoadFailed), view.job, paramMap)
    //   }
    //   else {
    //     addBillEdi()
    //   }
  }
  addBillEdi(event = null) {
    //   if (Config.configMap["creditOpen"] == "1") {
    //     CreditControlUtil.checkCreditByCompany(view.job.customerId, function (credit: CreditInfo) {
    //       var canEdi = true
    //       if (credit != null) {
    //         var tip = ""
    //         if (credit.isAmountExceeded || credit.isDateExceeded) {
    //           var config = CreditControlUtil.getCreditEDISetting()
    //           if (config.bl) {
    //             if (credit.isAmountExceeded)
    //               tip += this.view.$t('CargoMsg.Cargo_Limit')
    //             if (credit.isDateExceeded)
    //               tip += this.view.$t('CargoMsg.Cargo_AccountPeriod')
    //             MessageDialog.info(this.view.$t('SeaExport.CreditControlTheClient') + tip + this.view.$t('SeaExport.HasExceededCannotEDI'), null, null, null)
    //             canEdi = false
    //           }
    //         }
    //       }
    //       if (canEdi) {
    //         if (checkContainerUsage()) {
    //           title = this.view.$t('SeaExport.BlEdi')
    //           ediType = 2
    //           editStatus = 9
    //           if (Config.configMap["useEDITemplate"] == "1") {
    //             showEDITemplateWin(new ArrayCollection([view.job.key]))
    //           } else {
    //             EDI.getLadingBillEDI(view.job.key, editStatus, onExportEDISuccess, onExportEDIFailed)
    //           }
    //         }
    //         else {
    //           MessageDialog.info(this.view.$t('SeaExport.PackingDataNotCconsistent'), null, null, null)
    //         }
    //       }
    //     })
    //   }
    //   else {
    //     if (checkContainerUsage()) {
    //       title = this.view.$t('SeaExport.BlEdi')
    //       ediType = 2
    //       editStatus = 9
    //       if (Config.configMap["useEDITemplate"] == "1") {
    //         showEDITemplateWin(new ArrayCollection([view.job.key]))
    //       } else {
    //         EDI.getLadingBillEDI(view.job.key, editStatus, onExportEDISuccess, onExportEDIFailed)
    //       }
    //     }
    //     else {
    //       MessageDialog.info(this.view.$t('SeaExport.PackingDataNotCconsistent'), null, null, null)
    //     }
    //   }
  }
  /**
   * 检查是否全部装箱
   */
  checkContainerUsage() {
    //   if (parseInt(Config.configMap["ExportEdiCheckContainerUsage"]) == 0) {
    //     return true
    //   }
    //   var totalQuantity = 0
    //   var totalWeight: Number = 0.0
    //   var totalCubage: Number = 0.0
    //   var seaJob: SeaExportJob = view.job as SeaExportJob
    //   for each(var c: Container in seaJob.containers)
    //   {
    //     for each(var cu: ContainerUsage in c.containerUsage)
    //     {
    //       totalQuantity += cu.quantity
    //       totalWeight += cu.weight
    //       totalCubage += cu.cubage
    //     }
    //   }
    //   totalQuantity = Number(totalQuantity.toFixed())
    //   totalWeight = Number(totalWeight.toFixed(3))
    //   totalCubage = Number(totalCubage.toFixed(3))
    //   if (totalQuantity != seaJob.quantityActual) return false
    //   var diff: Number = Math.abs(totalWeight - seaJob.weightActual)
    //   if (diff > 0.001) return false//special handlement for floating number.
    //   diff = Math.abs(totalCubage - seaJob.cubageActual)
    //   if (diff > 0.001) return false
    //   return true
  }
  onContainerLoaded(event) {
    //   var job = event.result
    //   view.job.containers = job.containers
  }
  onContainerLoadFailed(event) {
    //   FlexGlobals.topLevelApplication.status = this.view.$t('SeaExport.LoadingOfPackingInformationFailed')
  }
  async init() {
    this.editVesselVoyageMode = Number(this.config.get('EditVesselVoyageMode'))
    this.editVoyageMode = Number(this.config.get('EditVoyageMode'))
    this.editInputVesselModel()
    this.isShowSalesFileCutoffDate = Number(this.config.get('showSalesFileCutoffDate')) === 1
    this.view.$checkPermission(['button_EDI_booking'])
    if (!this.view.$checkPermission(['button_EDI_booking']) && !this.user.admin) {
      this.view.showBookingEdi1 = false
    }
    this.view.showResubscribeBookingReceipt = this.view.$checkPermission(['button_SEBooking_resubscribeBookingReceipt'])
    this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
    this.syncSignDateBl = Number(this.config.get('syncSignDateBl'))
    this.combinedManifest = Number(this.config.get('CombinedManifest'))
  }
  async changeJob() {
    if (this.view.showEntrustmentState) {
      this.view.textEntrustmentState = ''
      await this.initLatestEntrustmentState()
    }
    await this.initPushDataChange()
    await this.initMblCargoDoc()
  }
  /**
   * fill view
   */
  async fillView() {
    if (this.view.isEditExcludeExportToImport) {
      this.currentVessel = this.vesselList.filter(p => p.englishName === this.job.vessel)[0]
      await this.getVoyageByVessel()
    }
    this.editInputVesselModel()
    if (this.view.isEditExcludeExportToImport) {
      await DateAutoInitRuleManage.getInstance().autoCalculateDateRule(this.job, this.job, 'SE')
    }
    JobUtils.changeField(this.job, this.job.relatedChangeField)
    if (!this.job.masterFlag) {
      this.view.showBookingEdi1 = this.job.containerLoadType !== 'LCL'
    } else {
      this.view.showBookingEdi1 = true
    }
    this.view.checkRouteCode = false
    if (this.job.voyageFlight && this.job.routeCode &&
        this._voyages && this._voyages.length > 0) {
      const data = this._voyages.filter(p => p.voyageNo === this.job.voyageFlight && p.routeCode === this.job.routeCode)
      if (data && data.length > 0) {
        this.view.checkRouteCode = true
      }
    }
    this.openSubscribePortPush = false
    getSubscribePortPushTenantList().then(res => {
      const list = res.data
      if (list && list.length > 0) {
        for (const tenant of list) {
          if (tenant.tenantId === this.view.$store.getters.tenantId) {
            this.openSubscribePortPush = true
            break
          }
        }
      }
    })
  }
  print() {
    //   if (view.job) {
    //     var params = new Object()
    //     params.jobuuid = view.job.key
    //     params.JOB_UUID = view.job.key
    //     TemplateSelectorWin.getInstance().showThisWin(view.job, "BACNKLETTER", params, view)
    //   }
  }
  /**
   * 实现自动带出V.，并且录入时追加数据，而不是覆盖
   */
  txtVoyageFocusInHandler() {
    let value = 'V.'
    if (!this.view.showJudgmentOfVoyageNo) {
      value = ''
    }
    if (this.job.voyageFlight) {
      value = this.job.voyageFlight
      this.job.voyageFlight = ''
    }
    this.view.$nextTick(() => {
      this.job.voyageFlight = value
      const elSelect = this.view.$refs.voyageFlight.$refs.advanceSelectRef
      const innerInput = elSelect.$children[0].$refs.input
      innerInput.value = this.job.voyageFlight
    })
  }
  async onVoyageFlightChange(data) {
    // 清空后clean和change事件避免多次调用
    if (this.view.cleanFlag) {
      return
    }
    this.view.cleanFlag = true
    try {
      let subscribeConfig = null
      await Promise.all([
        querySubscribeConfig({}).then(res => {
          if (res.data && res.data.length > 0) {
            subscribeConfig = res.data[0]
          }
        })
      ])
      let cleanPolPortInfo = false
      if (subscribeConfig && subscribeConfig.cleanPolPortInfo) {
        cleanPolPortInfo = true
      }
      await JobUtils.vesselOrVoyageChange(this.job, 'voyageFlight', data.value, this.view, this.view.oldVoyageFlight, cleanPolPortInfo)
      if (data.value) { // 客户点击“x”进行清空的时候，oldVessel不更新，用于比较船名是否发生变更
        this.view.oldVoyageFlight = data.value
      }
      const job = this.job
      job.voyageFlight = data.value
      if (this.voyageList) {
        // 同步航线代码逻辑
        if (job.carrierId) {
          // 如果job有船司，则按照船司+航次去同步
          let voyageData = null
          for (const voyage of this.voyageList) {
            if (voyage.voyageNo === job.voyageFlight && voyage.carrierId === job.carrierId) {
              voyageData = voyage
            }
          }
          // 找到值覆盖，没找到则清空
          if (voyageData) {
            job.routeCode = voyageData.routeCode
          } else {
            job.routeCode = ''
          }
        } else {
          // 如果没有船司，则按照航次去同步
          job.routeCode = data.routeCode
        }
      }
      if (job.routeCode) {
        this.view.checkRouteCode = true
      } else {
        this.view.checkRouteCode = false
      }
      if (job.bookingTerm === 'SB' && job.destinationPortCode && job.destinationPortCode.length && job.carrierId) {
        if (job.vessel && job.voyageFlight.length > 2) {
          const ediCode = await Vessel.getEDICode(job.vessel, job.voyageFlight, job.destinationPortCode, job.carrierId)
          if (ediCode) {
            job.vesselCode = ediCode
          }
        }
      }
      if (data.value) {
        await this.syncJonInformation(data)
      }
      // await JobUtils.changeManifestInfo(job, 'voyageFlight')
      this.syncAms('voyageFlight')
      await JobUtils.loadingShipDate(this.job)
    } finally {
      setTimeout(() => {
        this.view.cleanFlag = false
      }, 100)
    }
  }
  /**
   * vessel change
   */
  async onVesselSelectionChange(data) {
    // 清空后clean和change事件避免多次调用
    if (this.view.cleanFlag) {
      return
    }
    this.view.cleanFlag = true
    try {
      let subscribeConfig = null
      await Promise.all([
        querySubscribeConfig({}).then(res => {
          if (res.data && res.data.length > 0) {
            subscribeConfig = res.data[0]
          }
        })
      ])
      let cleanPolPortInfo = false
      if (subscribeConfig && subscribeConfig.cleanPolPortInfo) {
        cleanPolPortInfo = true
      }
      await JobUtils.vesselOrVoyageChange(this.job, 'vessel', data.value, this.view, this.view.oldVessel, cleanPolPortInfo)
      await JobUtils.loadingShipDate(this.job)
      // CARGO-32609 外红：更改船名后，没有弹窗跳出提醒
      if (data.value) { // 客户点击“x”进行清空的时候，oldVessel不更新，用于比较船名是否发生变更
        this.view.oldVessel = data.value
      }
      this.currentVessel = data
      this.job.vessel = data.value
      this.syncAms('vessel')
      await this.getVoyageByVessel()
      if (data.value && data.uuid) {
        this.job.vesselIMO = this.currentVessel.imoCode
        await this.getVesselCarrier()
        // 若存在imo也需要同步ams页签
        this.syncAms('vesselIMO')
      } else {
        this.job.vesselIMO = ''
      }
    } finally {
      setTimeout(() => {
        this.view.cleanFlag = false
      }, 100)
    }
  }
  async getVoyageByVessel() {
    if (this.currentVessel && this.currentVessel.vesselId) {
      const voyages = await Voyage.getVoyage(this.currentVessel.vesselId)
      this.voyageList = voyages
      this._voyages = Object.values(
        voyages.reduce((acc, cur) => {
          const key = cur.voyageNo
          // 1. 如果还没出现过，直接放入
          if (!acc[key]) {
            acc[key] = cur
          } else {
            // 2. 如果当前这条是 主船司数据，则用当前这条替换
            if (cur.masterCarrier === true) {
              acc[key] = cur
            }
            // 3. 如果已存在的不是 masterCarrier 且当前这条也不是，就不动，保留第一条
          }
          return acc
        }, {})
      )
    } else {
      this._voyages = []
    }
  }
  async onVesselAndVoyageChange(value) {
    if (!value) {
      this.job.voyageFlight = ''
      this.job.vessel = ''
      this.job.vesselIMO = ''
      this.job.routeCode = ''
    }
    if (value && value.trim().length > 0) {
      const parts = value.trim().split(/[\s\/]+/)
      let vesselData
      const selectVesselSchedule = Number(this.config.get('SelectVesselSchedule')) === 1
      const englishNames = this.vesselList
        .map(item => item?.englishName) // 使用可选链操作符
        .filter(Boolean)
      if (parts.length > 1) {
        // 如果有多个部分，最后一个作为航次，其余作为船名
        let voyageFlight = parts.pop() // 获取最后一个单词作为航次
        const vessel = parts.join(' ') // 其他部分作为船名
        if (this.view.showJudgmentOfVoyageNo && !voyageFlight.toUpperCase().includes('V.')) {
          voyageFlight = 'V.' + voyageFlight
        }
        this.job.voyageFlight = voyageFlight
        if (selectVesselSchedule && !englishNames.includes(vessel)) {
          return
        }
        vesselData = this.vesselList.find(item => {
          return item && item.englishName === vessel
        })
        this.job.vessel = vessel
      } else {
        if (selectVesselSchedule && !englishNames.includes(value.trim())) {
          return
        }
        // 如果只有一个部分，默认全部为船名
        this.job.vessel = value.trim() // 全部内容作为船名
        vesselData = this.vesselList.find(item => {
          return item && item.englishName === value.trim()
        })
      }
      if (vesselData) {
        vesselData.value = this.job.vessel
        await this.onVesselSelectionChange(vesselData)
        if (Array.isArray(this._voyages) && this.job.voyageFlight) {
          const voyage = this._voyages.find(item => {
            return item && item.voyageNo === this.job.voyageFlight
          })
          if (voyage) {
            voyage.value = this.job.voyageFlight
            this.txtVoyageFocusInHandler()
            await this.onVoyageFlightChange(voyage)
          }
        }
      }
    }
  }
  syncAms(field) {
    const cargoDocs = this.job.seaCargoDoc
    if (!cargoDocs || cargoDocs.length === 0) {
      return
    }
    const amsCargoDoc = []
    for (const item of cargoDocs) {
      if (item.docType === CargoDocConsts.AMS) {
        item[field] = this.job[field]
        amsCargoDoc.push(item)
      }
    }
    this.context.modifiedData.seaCargoDoc = this.context.modifiedData.seaCargoDoc || []
    mergeArray(this.context.modifiedData.seaCargoDoc, amsCargoDoc) // 只记住修改过的数据
  }
  /**
   * 获取该委托单位对应的约号信息
   * @returns {Promise<void>}
   */
  async getContractNoList(customerUuid, loadType) {
    if (customerUuid && loadType) {
      const result = await getContractNoList({ companyUuid: customerUuid, loadType: loadType, ignoreEmptyContractNoPrice: true })
      this.view.contractNos = result.data
    } else {
      this.view.contractNos = []
    }
  }

  /**
   * 获取船舶呼号code
   */
  async getVesselCarrier() {
    const vessel = new Vessel(this.currentVessel)
    const vesselCarriers = await vessel.getVesselCarriers()
    // 不理解之前船舶呼号代码 推测是bug
    for (const carrier of vesselCarriers) {
      if (carrier.carrierId === this.job.carrierId) {
        this.job.vesselCode = carrier.edicode
      }
    }
    for (const carrier of vesselCarriers) {
      if (carrier.carrierId === this.job.carrierId) {
        this.job.carrierCode = carrier.edicode
      }
    }
  }
  async getCarrierCodeData(vesselName) {
    this.currentVessel = this.vesselList.filter(p => p.englishName === vesselName)[0]
    const vessel = new Vessel(this.currentVessel)
    const vesselCarriers = await vessel.getVesselCarriers()
    for (const carrier of vesselCarriers) {
      if (carrier.carrierId === this.job.carrierId) {
        return carrier.edicode
      }
    }
    return ''
  }
  /**
   * 拼箱小票，不允许编辑：目的港代理、船名、航次、订舱单位、船公司、主单运费条款、卸货港
   */
  lclslaveEnabledCl() {
    this.lclslaveEnabled = this.view.isEdit
    if (this.lclslaveEnabled && this.job && this.job.lclMasterUuid) {
      this.lclslaveEnabled = false
    }
    this.lclslaveEnabledExcludeExportToImport = this.view.isEditExcludeExportToImport
    if (this.lclslaveEnabledExcludeExportToImport && this.job && this.job.lclMasterUuid) {
      this.lclslaveEnabledExcludeExportToImport = false
    }
  }
  /**
   * 初始化最新的委托状态
   */
  async initLatestEntrustmentState() {
    if (this.statusFlag.has('initLatestEntrustmentState')) {
      return
    }
    this.statusFlag.set('initLatestEntrustmentState', true)
    try {
      if (this.job) {
        if (this.job.relatedJob) { // 委托方
          const state = await CrossTenantHistory.queryLatestState(this.job.jobNo)
          this.stateResultHandler(state)
        } else if (this.job.trustFromJob) { // 接收方
          const state = await CrossTenantHistory.queryLatestStateFromReceiver(this.job.jobNo)
          this.stateResultHandler(state)
        }
      }
    } finally {
      this.statusFlag.delete('initLatestEntrustmentState')
    }
  }
  stateResultHandler(latestState) {
    let entrustmentStates = []
    if (this.job.relatedJob) {
      entrustmentStates = CROSS_TENANT_HISTORY_STATES
    } else if (this.job.trustFromJob) {
      entrustmentStates = CROSS_TENANT_HISTORY_STATES_RECEIVER
    }
    for (const crossState of entrustmentStates) {
      if (crossState.code === latestState) {
        this.view.textEntrustmentState = crossState.chineseName
        break
      }
    }
  }
  entrustHisBtnClickHandler() {
    const job = this.job
    const dialog = this.view.crossTenantHistoryDialog
    if (job.relatedJob) {
      dialog.entrustmentType = '0'
    } else if (job.trustFromJob) {
      dialog.entrustmentType = '1'
    } else {
      dialog.entrustmentType = ''
    }
    dialog.jobNo = job.jobNo
    dialog.visible = true
  }
  entrustmentStateShowHandler() {
    this.view.textEntrustmentState = ''
    this.initLatestEntrustmentState()
  }
  /**
   * 推送数据改变标识
   */
  async initPushDataChange() {
    const job = this.job
    if (job.uuid) {
      const lclMaster = await new SeaExportJob(job).getLclMaster()
      const loadJob = lclMaster !== null ? lclMaster : job
      await new SeaExportJob(loadJob).loadPushHistoryLogs()
      this.loadPushHistoryLogsHandler(loadJob)
    }
  }
  loadPushHistoryLogsHandler(loadJob) {
    AutoContaninerFactory.getInstance().job = loadJob
    const fieldClass = this.view.fieldClass
    const job = this.job
    const recordId = loadJob.uuid
    const blue = 'date-blue'
    fieldClass.vessel = DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.Vessel'), job.vessel, recordId) ? blue : ''
    fieldClass.voyageFlight = DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.Voyage'), job.voyageFlight, recordId) ? blue : ''
    fieldClass.portDistrict = DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.HarborDistrict'), job.portDistrict, recordId) ? blue : ''
    fieldClass.terminalOpendate = DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.CYOpeningTime'), DateUtils.formatStandardDateTime(job.terminalOpendate), recordId) ? blue : ''
    fieldClass.terminalCutoff = DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.PortAreaCYCutOffTime'), DateUtils.formatStandardDateTime(job.terminalCutoff), recordId) ? blue : ''
    fieldClass.unBerthPlanDate = DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.PlanDepartureTime'), DateUtils.formatStandardDateTime(job.unBerthPlanDate), recordId) ? blue : ''
    fieldClass.actualUnBerthPlanDate = DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.RealDepartureTime'), DateUtils.formatStandardDateTime(job.actualUnBerthPlanDate), recordId) ? blue : ''
    fieldClass.berthPlanDate = DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.PlannedBerthingTime'), DateUtils.formatStandardDateTime(job.berthPlanDate), recordId) ? blue : ''
    fieldClass.actualBerthPlanDate = DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.ActualBerthingTime'), DateUtils.formatStandardDateTime(job.actualBerthPlanDate), recordId) ? blue : ''
    fieldClass.berthPlanPlace = DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.PlannedDockingBerths'), job.berthPlanPlace, recordId) ? blue : ''
    fieldClass.actualBerthPlanPlace = DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.TheActualDockingBerths'), job.actualBerthPlanPlace, recordId) ? blue : ''
    fieldClass.realArrivalsDate = DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.ActualTimeOfArrivalThePort'), job.realArrivalsDate, recordId) ? blue : ''

    const red = 'change_red'
    const titleRed = 'red'
    fieldClass.vessel = job.change_vessel ? red : fieldClass.vessel
    fieldClass.vesselTitle = job.change_vessel ? titleRed : ''
    fieldClass.voyageFlight = job.change_voyageFlight ? red : fieldClass.voyageFlight
    fieldClass.voyageFlightTitle = job.change_voyageFlight ? titleRed : ''
    fieldClass.soNo = job.change_soNo ? red : ''
    fieldClass.soNoTitle = job.change_soNo ? titleRed : ''
    fieldClass.secondVesselVoyage = job.change_secondVesselVoyage ? red : ''
    fieldClass.secondVesselVoyageTitle = job.change_secondVesselVoyage ? titleRed : ''
    fieldClass.secondVoyage = job.change_secondVoyage ? red : ''
    fieldClass.secondVoyageTitle = job.change_secondVoyage ? titleRed : ''
  }
  /**
   * 编辑船名航次模式
   */
  editInputVesselModel() {
    if (this.job) {
      if (this.job.vessel) {
        const curVessel = this.vesselList.filter(p => p.englishName === this.job.vessel)[0]
        if (!curVessel) this.vesselList.push({ englishName: this.job.vessel })
      }
      if (this.job.voyageFlight && this._voyages) {
        const curVoyage = this._voyages.filter(p => p.voyageNo === this.job.voyageFlight)[0]
        if (!curVoyage) {
          this._voyages.push({ voyageNo: this.job.voyageFlight })
        }
      }
    }
    switch (this.editVesselVoyageMode) {
      case 1:
        this._allowEditingVessel = true
        break
      case 2:
        if (this.job && this.job.bookingTerm !== 'OS') {
          this._allowEditingVessel = true
        } else {
          this._allowEditingVessel = false
        }
        break
      case 3:
        this._allowEditingVessel = false
        break
      default:
        break
    }
  }
  editingChanged() {
    // 跨tenant委托:发送方订舱页签始终应可编辑
    let isCrossTenant = false
    const bookingAgentSender = this.companyList.filter(p => p.cmpIdx === Number(this.job.bookingAgent))[0]
    if (bookingAgentSender) {
      isCrossTenant = bookingAgentSender.relateTenantId > 0 && this.job.relatedJob
    }
    if (!isCrossTenant) {
      const destinationAgentSender = this.companyList.filter(p => p.cmpIdx === Number(this.job.destinationAgent))[0]
      if (destinationAgentSender) {
        isCrossTenant = destinationAgentSender.relateTenantId > 0 && this.job.relatedJob
      }
    }
    this.view.isCrossTenant = isCrossTenant
    // 判断是否是跨tenant委托,分发送方和委托方两种情形
    if (this.job.relatedJob) { // 发送方
      this.isCrossJob = bookingAgentSender ? bookingAgentSender.relateTenantId > 0 : false
    } else if (this.job.trustFromJob) { // 接收方
      const customerReceiver = this.companyList.filter(p => p.cmpIdx === this.job.customerId)[0]
      this.isCrossJob = customerReceiver ? customerReceiver.relateTenantId > 0 : false
    }
    this.lclslaveEnabledCl()
  }
  async changeMbl() {
    this.syncAms('mbl')
  }

  async isExistMBLSeaExport(mbl) {
    const job = this.job
    if (!job || !job.opOffice) {
      return 0
    }
    if (mbl && mbl.trim()) {
      const count = await SeaExportJob.isExistMBLSeaExport(job.opOffice, 'SE', mbl, job.uuid, job.etd)
      return count
    } else {
      return 0
    }
  }

  async syncJonInformation(voyage) {
    // 1. 先判断当前租户是否开启数据推送配置
    if (!voyage.vesselId || this.openSubscribePortPush || (this.editVesselVoyageMode === 1 && this.editVoyageMode === 1 && this.combinedManifest === 1)) return
    const job = this.job
    // 2.未开通港区推送，并且业务状态时正操作、预提交, 业务的创建日期不超过3个月的(90天)
    if (this.isAllowUpdateJob(job) && (!job.uuid || (job.uuid && DateUtils.getBetweenDays(job.dateCreated, new Date()) <= 90))) {
      const voyages = await Voyage.getVoyage(voyage.vesselId)
      if (voyages && voyages.length > 0) {
        // 1.根据起运港匹配,更新业务港区、实际开航日期（ATD）、开航日期（ETD）、截单日期、截港日期、截关日期
        const oldEtd = job.etd
        for (const item of voyages) {
          let isFound = false
          if (item.voyageNo === job.voyageFlight) {
            if (item.segments && item.segments.length > 0) {
              for (const segment of item.segments) {
                if (segment.portOfCall && segment.portOfCall === job.loadingPortCode) {
                  job.portDistrict = segment.berth
                  job.atd = segment.atd
                  if (segment.etd) {
                    job.etd = segment.etd
                  }
                  job.fileCutoff = segment.fileCutoff
                  job.terminalCutoff = segment.terminalCutoff
                  job.customCutoff = segment.customCutoff
                  isFound = true
                  break
                }
              }
            }
          }
          if (isFound) {
            break
          }
        }
        const etdChanged = dateCompare(job.etd, oldEtd) !== 0
        if (etdChanged) {
          // 2.更新ETD，提单界面（MBL/HBL/MBL拆并单/HBL拆并单）的签发日期要一起同步
          if (this.syncSignDateBl === 0) {
            const cargoDocs = await new SeaExportJob(job).getSeaCargoDoc()
            if (cargoDocs && cargoDocs.length > 0) {
              for (const cargoDoc of cargoDocs) {
                const allow = cargoDoc.docType && (cargoDoc.docType === CargoDocConsts.MBL || cargoDoc.docType === CargoDocConsts.MBL2 ||
                    cargoDoc.docType === CargoDocConsts.HBL || cargoDoc.docType === CargoDocConsts.HBL2 ||
                    cargoDoc.docType === CargoDocConsts.HAWB2) && cargoDoc.state < 2 && (!cargoDoc.signDateBL ||
                    (oldEtd && dateCompare(cargoDoc.signDateBL, oldEtd) === 0))
                if (allow) {
                  cargoDoc.signDateBL = job.etd
                }
              }
            }
          }
          // 3.更新费用业务日期
          const charges = await new SeaExportJob(job).getCharges()
          if (charges && charges.length > 0) {
            for (const charge of charges) {
              charge.businessDate = job.etd
            }
          }
        }
        // 4.根据卸货港匹配，更新到港日期（ETA）、实际到港日期（ATA）
        for (const item of voyages) {
          let isFound = false
          if (item.voyageNo === job.voyageFlight) {
            if (item.segments && item.segments.length > 0) {
              for (const segment of item.segments) {
                if (segment.portOfCall && segment.portOfCall === job.dischargingPortCode) { // 根据起运港匹配
                  job.eta = segment.eta
                  job.ata = segment.ata
                  isFound = true
                  break
                }
              }
            }
          }
          if (isFound) {
            break
          }
        }
      }
    }
  }
  isAllowUpdateJob(job) {
    /* 获取需要同步的业务状态，默认正操作、预提交 */
    const states = []
    const allowUpdateSEJobState = this.config.get('AllowUpdateSEJobState')
    if (allowUpdateSEJobState) {
      const stateTexts = allowUpdateSEJobState.split(',')
      for (const stateText of stateTexts) {
        switch (stateText) {
          case '0':
            states.push(0)
            break
          case '1':
            states.push(1)
            break
          case '2':
            states.push(2)
            break
          case '11':
            states.push(11)
            break
          default:
            break
        }
      }
    }
    if (states.length === 0) {
      states.push(0)
      states.push(11)
    }
    return states.includes(job.jobState)
  }

  /**
   * 初始化获取mbl页签收发通
   */
  async initMblCargoDoc() {
    let hasMbl = false
    const cargoDocList = await new SeaExportJob(this.job).getSeaCargoDoc()
    if (cargoDocList.length > 0) {
      for (const doc of cargoDocList) {
        if (doc.docType === 'MBL') {
          this.mblCargoDoc = doc
          hasMbl = true
          break
        }
      }
    }
    // 订舱页签禁用收发通状态
    this.view.enableShipperLocked = this.job.shipperLock || !this.job.signMBL || !hasMbl
  }

  // 变更已锁定发货人勾选框时
  async refreshShipperLock() {
    let hasMbl = false
    const cargoDocList = this.job.seaCargoDoc
    if (cargoDocList.length > 0) {
      for (const doc of cargoDocList) {
        if (doc.docType === 'MBL') {
          hasMbl = true
          break
        }
      }
    }
    // 订舱页签禁用收发通状态
    this.view.enableShipperLocked = this.job.shipperLock || !this.job.signMBL || !hasMbl
  }

  /**
   * 清空收发通
   */
  onClear(type) {
    switch (type) {
      case 1:
        this.mblCargoDoc.shipperCode = ''
        this.mblCargoDoc.shipperLine1 = ''
        this.mblCargoDoc.shipperLine2 = ''
        this.mblCargoDoc.shipperLine3 = ''
        this.mblCargoDoc.shipperLine4 = ''
        this.mblCargoDoc.shipperLine5 = ''
        this.mblCargoDoc.shipperLine6 = ''
        this.mblCargoDoc.shipperLine7 = ''
        break
      case 2:
        this.mblCargoDoc.consigneeCode = ''
        this.mblCargoDoc.consigneeLine1 = ''
        this.mblCargoDoc.consigneeLine2 = ''
        this.mblCargoDoc.consigneeLine3 = ''
        this.mblCargoDoc.consigneeLine4 = ''
        this.mblCargoDoc.consigneeLine5 = ''
        this.mblCargoDoc.consigneeLine6 = ''
        this.mblCargoDoc.consigneeLine7 = ''
        break
      case 3:
        this.mblCargoDoc.notifyCode = ''
        this.mblCargoDoc.notifyLine1 = ''
        this.mblCargoDoc.notifyLine2 = ''
        this.mblCargoDoc.notifyLine3 = ''
        this.mblCargoDoc.notifyLine4 = ''
        this.mblCargoDoc.notifyLine5 = ''
        this.mblCargoDoc.notifyLine6 = ''
        this.mblCargoDoc.notifyLine7 = ''
        break
      default:
        break
    }
  }
  async onscNoChange(data) {
    if (data && data.uuid) {
      const validityStart = data.validityStart
      const validityEnd = data.validityEnd
      if (validityStart && validityEnd) {
        const etd = this.job.etd
        const isValidTimeRange = this.isValidTimeRange(etd, validityStart, validityEnd)
        if (!isValidTimeRange) {
          const validPeriod = DateUtils.formatStandardDate(validityStart) + ' ~ ' + DateUtils.formatStandardDate(validityEnd)
          const message = this.view.$t('SeaExport.ValidPeriodEtdMessage', [validPeriod, DateUtils.formatStandardDate(etd)])
          await this.view.$confirm(this.view.$t('SeaExport.ValidityPeriodCannotCoverETD', [message]),
            this.view.$t('common.btn.confirm'), {
              confirmButtonText: this.view.$t('common.btn.ok'),
              cancelButtonText: this.view.$t('common.btn.cancel'),
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }
          ).then(async() => {
            await this.checkScNoChange(data)
          }).catch(() => {
            this.job.scNo = ''
            this.view.$refs.scNoSelect && this.view.$refs.scNoSelect.fetchData()
          })
        } else {
          await this.checkScNoChange(data)
        }
      } else {
        this.job.scNo = data.value
      }
      this.job.bookingTerm = data.priceNature
      const contractData = await getNacInfo({ uuid: data.uuid })
      if (contractData && contractData.data.length > 0) {
        if (contractData.data.length > 1) {
          this.job.na = ''
        } else {
          this.job.na = contractData.data[0].nac
        }
        this.nacList = contractData.data
      } else {
        this.job.na = ''
        this.nacList = []
      }
    }
    if (data && !data.uuid) {
      this.job.scNo = data.value
    }
    // 处理清空操作
    if (!data.value) {
      this.job.scNo = data.value
    }
  }

  async checkScNoChange(data) {
    this.job.scNo = data.value
    // 船公司为空
    if (!this.job.carrierId && data.shippingCompany) {
      this.job.carrierId = data.shippingCompany
    }
    if (data.shippingCompany && data.shippingCompany !== this.job.carrierId) {
      this.view.$confirm(this.view.$t('SeaExport.ShippingCompanyAndBaseDifferent'), this.view.$t('common.tips.prompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('SeaExport.GiveUp'),
        type: 'warning'
      }).then(() => {
        this.job.carrierId = data.shippingCompany
        this.scNoAutoCompleteChangeAirLine(data)
      }).catch(() => {
        this.scNoAutoCompleteChangeAirLine(data)
      })
    } else {
      await this.scNoAutoCompleteChangeAirLine(data)
    }
  }
  async scNoAutoCompleteChangeAirLine(data) {
    // 航线为空
    if (!this.job.airLine) {
      let routeCodes = []
      if (typeof data.applicableRoutes === 'string') {
        routeCodes = data.applicableRoutes.split(',').map(s => s.trim()).filter(Boolean)
      } else if (Array.isArray(data.applicableRoutes)) {
        routeCodes = data.applicableRoutes
      }
      if (routeCodes.length > 0) {
        const regionList = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
        const codeToNameMap = {}
        regionList.forEach(item => {
          codeToNameMap[item.code] = this.view.$store.getters.language === 'zh' ? item.name : item.nameEnglish
        })
        const routeOptionsCn = routeCodes.map(code => codeToNameMap[code] || code)
        if (routeOptionsCn.length === 1) {
          this.job.airLine = routeOptionsCn[0] || ''
        } else {
          routeOptionsCn.push(this.view.$t('SeaExport.DoNotBackFill'))
          this.view.routeOptions = routeOptionsCn
          this.view.selectedRoute = routeOptionsCn[0] || ''
          this.view.routeTitle = this.view.$t('SeaExport.BackFillToRoute')
          this.view.showRouteDialog = true
        }
      }
    }
    // 航线不为空
    if (this.job.airLine) {
      let routeCodes = []
      if (typeof data.applicableRoutes === 'string') {
        routeCodes = data.applicableRoutes.split(',').map(s => s.trim()).filter(Boolean)
      } else if (Array.isArray(data.applicableRoutes)) {
        routeCodes = data.applicableRoutes
      }
      if (routeCodes.length > 0) {
        const regionList = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
        const codeToNameMap = {}
        regionList.forEach(item => {
          codeToNameMap[item.code] = this.view.$store.getters.language === 'zh' ? item.name : item.nameEnglish
        })
        const routeOptionsCn = routeCodes.map(code => codeToNameMap[code] || code)
        const findAirLine = routeOptionsCn.find(item => item === this.job.airLine)
        if (!findAirLine && routeOptionsCn.length === 1) {
          this.view.routeOptions = routeOptionsCn
          this.view.selectedRoute = routeOptionsCn[0] || ''
          this.view.routeTitle = this.view.$t('SeaExport.ApplicableRoutesDifferent')
          this.view.showRouteDialog = true
        } else if (!findAirLine && routeOptionsCn.length >= 1) {
          routeOptionsCn.push(this.view.$t('SeaExport.DoNotBackFill'))
          this.view.routeOptions = routeOptionsCn
          this.view.selectedRoute = routeOptionsCn[0] || ''
          this.view.routeTitle = this.view.$t('SeaExport.MultipleApplicableRoutesDifferent')
          this.view.showRouteDialog = true
        }
      }
    }
  }
  isValidTimeRange(value, validityStart, validityEnd) {
    const selectedTime = new Date(value).getTime()
    const start = new Date(validityStart).getTime()
    const end = new Date(validityEnd).getTime()
    return selectedTime >= start && selectedTime <= end
  }
  /**
   * 发货人选择
   */
  async shipperAutoCompleteChange(data) {
    this.mblCargoDoc.shipperId = data.value
    JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'shipper', 1)
    const company = new Company(data)
    await company.getMainfestAddress()
    this.applyShipperManifestAddress(data)
  }
  applyShipperManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.mblCargoDoc.shipperCode = company.englishName
      this.mblCargoDoc.shipperLine1 = manifestaddress.addressLine1
      this.mblCargoDoc.shipperLine2 = manifestaddress.addressLine2
      this.mblCargoDoc.shipperLine3 = manifestaddress.addressLine3
      this.mblCargoDoc.shipperLine4 = manifestaddress.addressLine4
      this.mblCargoDoc.shipperLine5 = manifestaddress.addressLine5
      this.mblCargoDoc.shipperLine6 = manifestaddress.addressLine6
      this.mblCargoDoc.shipperLine7 = manifestaddress.addressLine7
    } else {
      this.mblCargoDoc.shipperCode = ''
      this.mblCargoDoc.shipperLine1 = ''
      this.mblCargoDoc.shipperLine2 = ''
      this.mblCargoDoc.shipperLine3 = ''
      this.mblCargoDoc.shipperLine4 = ''
      this.mblCargoDoc.shipperLine5 = ''
      this.mblCargoDoc.shipperLine6 = ''
      this.mblCargoDoc.shipperLine7 = ''
    }
  }
  /**
   * 收货人选择
   */
  async consigneeAutoCompleteChange(data) {
    this.mblCargoDoc.consigneeId = data.value
    JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'consignee', 1)
    const company = new Company(data)
    await company.getMainfestAddress()
    this.applyConsigneeManifestAddress(data)
  }
  applyConsigneeManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.mblCargoDoc.consigneeCode = company.englishName
      this.mblCargoDoc.consigneeLine1 = manifestaddress.addressLine1
      this.mblCargoDoc.consigneeLine2 = manifestaddress.addressLine2
      this.mblCargoDoc.consigneeLine3 = manifestaddress.addressLine3
      this.mblCargoDoc.consigneeLine4 = manifestaddress.addressLine4
      this.mblCargoDoc.consigneeLine5 = manifestaddress.addressLine5
      this.mblCargoDoc.consigneeLine6 = manifestaddress.addressLine6
      this.mblCargoDoc.consigneeLine7 = manifestaddress.addressLine7
    } else {
      this.mblCargoDoc.consigneeCode = ''
      this.mblCargoDoc.consigneeLine1 = ''
      this.mblCargoDoc.consigneeLine2 = ''
      this.mblCargoDoc.consigneeLine3 = ''
      this.mblCargoDoc.consigneeLine4 = ''
      this.mblCargoDoc.consigneeLine5 = ''
      this.mblCargoDoc.consigneeLine6 = ''
      this.mblCargoDoc.consigneeLine7 = ''
    }
  }

  /**
   * 通知人选择
   */
  async notifyAutoCompleteChange(data) {
    this.mblCargoDoc.notifyId = data.value
    JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'notify', 1)
    const company = new Company(data)
    await company.getMainfestAddress()
    this.applyNotifyManifestAddress(data)
  }
  applyNotifyManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.mblCargoDoc.notifyCode = company.englishName
      this.mblCargoDoc.notifyLine1 = manifestaddress.addressLine1
      this.mblCargoDoc.notifyLine2 = manifestaddress.addressLine2
      this.mblCargoDoc.notifyLine3 = manifestaddress.addressLine3
      this.mblCargoDoc.notifyLine4 = manifestaddress.addressLine4
      this.mblCargoDoc.notifyLine5 = manifestaddress.addressLine5
      this.mblCargoDoc.notifyLine6 = manifestaddress.addressLine6
      this.mblCargoDoc.notifyLine7 = manifestaddress.addressLine7
    } else {
      this.mblCargoDoc.notifyCode = ''
      this.mblCargoDoc.notifyLine1 = ''
      this.mblCargoDoc.notifyLine2 = ''
      this.mblCargoDoc.notifyLine3 = ''
      this.mblCargoDoc.notifyLine4 = ''
      this.mblCargoDoc.notifyLine5 = ''
      this.mblCargoDoc.notifyLine6 = ''
      this.mblCargoDoc.notifyLine7 = ''
    }
  }

  /**
   * 抄录收货人
   */
  onCopyConsignee() {
    this.mblCargoDoc.notifyCode = this.mblCargoDoc.consigneeCode
    this.mblCargoDoc.notifyLine1 = this.mblCargoDoc.consigneeLine1
    this.mblCargoDoc.notifyLine2 = this.mblCargoDoc.consigneeLine2
    this.mblCargoDoc.notifyLine3 = this.mblCargoDoc.consigneeLine3
    this.mblCargoDoc.notifyLine4 = this.mblCargoDoc.consigneeLine4
    this.mblCargoDoc.notifyLine5 = this.mblCargoDoc.consigneeLine5
    this.mblCargoDoc.notifyLine6 = this.mblCargoDoc.consigneeLine6
    this.mblCargoDoc.notifyLine7 = this.mblCargoDoc.consigneeLine7
  }

  /**
   * 加载船期信息
   */
  async loadShippingSchedules() {
    const job = this.job
    // 判断当前用户是否已忽略
    const hasLoad = LocalStorageUtils.getConfiguration('loadShippingSchedules_' + job.uuid)
    if (!job.uuid || !this.view.readonly || job.lclMasterUuid || job.jobState !== 0) {
      return
    }
    const params = {
      vessel: job.vessel,
      voy: cargoDocUtil.replaceVoyage(job.voyageFlight, true),
      portCode: job.loadingPortCode,
      jobUuid: job.uuid,
      tenantId: this.view.$store.getters.tenantId
    }
    await Promise.all([getShippingScheduleDistrict({ jobUuid: job.uuid,
      tenantId: this.view.$store.getters.tenantId }).then(res => {
      this.view.hasChooseShippingSchedule = !!res.data
      this.view.chooseShippingSchedule = res.data || ''
    }), shippingSchedules(params).then(res => {
      // 获取船期列表
      this.view.shippingSchedules = res.data
    })])
    if (hasLoad === 1) {
      return
    }
    // 判断是否弹出多船期提醒
    if (!this.view.hasChooseShippingSchedule && this.view.shippingSchedules && this.view.shippingSchedules.length > 1) {
      this.view.$confirm(this.view.$t('CargoMsg.Cargo_MoreShippingSchedulesTips'), this.view.$t('common.tips.prompt'), {
        confirmButtonText: this.view.$t('CargoMsg.Cargo_ChooseShippingSchedules'),
        cancelButtonText: this.view.$t('CargoMsg.Cargo_Ignore'),
        closeOnClickModal: false,
        showClose: false,
        closeOnPressEscape: false,
        type: 'info'
      }).then(() => {
        this.view.showMoreShippingSchedule = true
        this.view.isChooseShippingScheduleBtn = false
      }).catch(() => {
        // 记录忽略，不在提醒
        LocalStorageUtils.setConfiguration('loadShippingSchedules_' + job.uuid, '1')
      })
    }
  }

  /**
   * 选择开航日期更新分单签单日期，订舱航期
   */
  async ETDChangeEvent(value) {
    const job = this.job
    const oldValue = job.etd
    job.etd = value
    // CARGO-23752 【海运订舱极速版】-HBL 签发日期需要由【基本页签】实际开航日期(ATD)自动带出 主票下的小票数据在后端处理
    const cargoDocList = await new SeaExportJob(job).getSeaCargoDoc()
    if (cargoDocList && cargoDocList.length > 0 && parseInt(this.config.get('syncSignDateBl')) === 0) {
      for (const d of cargoDocList) {
        const allow = d.docType && (d.docType === 'MBL' || d.docType === 'MBL2') && d.state < 2 && (!d.signDateBL || (oldValue && dateCompare(d.signDateBL, oldValue) === 0))
        if (allow) {
          d.signDateBL = value
        }
      }
    }
    if (value) {
      let day = Number(this.config.get('SESignDateHBLRange'))
      if (isNaN(day) || day <= 0) {
        day = 3
      }
      day += 1
      // 截单日期默认天数
      const fileCutoffDay = Number(this.config.get('SEFileCutoffDetaultDay'))
      if (fileCutoffDay > 0) {
        const date = DateUtils.getFourDaysAgoWithoutHoliday(value, fileCutoffDay)
        const fileCutoff = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12)
        job.fileCutoff = DateUtils.formatStandardDateTime(fileCutoff)
      }
    }
  }
  // 获取开航日期后面的星期几
  getSailingDay() {
    if (this.job.etd) {
      this.job.sailingDay = String(new Date(this.job.etd)).substr(0, 3).toUpperCase()
    } else {
      this.job.sailingDay = ''
    }
  }
  /**
   * 起运港修改
   */
  async loadingPortCodeChange(data) {
    const job = this.job
    job.loadingPortCode = data.value
    await new TabBookingAbstract(this.view).portChange()
    // 主票起运港改变，小票的提单起运港也要改变
    if (job.lclSlaves && job.lclSlaves.length > 0) {
      const seaPorts = this.view.$refs.loadingPortCode.options
      const ports = seaPorts.filter(p => p.code === job.loadingPortCode)
      if (ports.length > 0) {
        const loadingPort = ports[0]
        for (const item of job.lclSlaves) {
          const slave = new SeaExportJob(item)
          const hdoc = slave.getCargoDocByType('HBL', true)
          const mdoc = slave.getCargoDocByType('MBL', true)
          if (hdoc) {
            hdoc.loadingPort = loadingPort.englishName
            hdoc.loadingPortCode = job.loadingPortCode
          }
          if (mdoc) {
            mdoc.loadingPort = loadingPort.englishName
            mdoc.loadingPortCode = job.loadingPortCode
          }
        }
      }
    }
  }
  /**
   * copy for MBL
   */
  async cargoDocChangeHandler() {
    const job = new SeaExportJob(this.job)
    const mbl = await job.getCargoDocByType('MBL', false)
    if (mbl && mbl.state > 0) {
      SeaCargoDoc.copyInfoFromJobPort(job, mbl).then(r => {})
    }
  }
}
